
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {GameModeTransitionControllerWithView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionControllerWithView";
import {GameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {HarlequinBackground} from "../../background/HarlequinBackground";

export class HarlequinTransitionController extends GameModeTransitionControllerWithView {

    private _isOutro:boolean = false;
    private _restore:boolean = false;
    private _freespinTriggeredThisSpin:boolean;
    private _wildMultipliers:number [] = [];

    constructor(fromMode:string, toMode:string, view:GameModeTransitionView, isOutro:boolean = false) {
        super(fromMode, toMode, view);

        this._isOutro = isOutro;
    }

    finish() {
        if(!this._isOutro) {
            HarlequinGameModuleConfig.harlequinSignView.enterMode(this._fromMode, this._toMode, undefined, this._restore, this._freespinTriggeredThisSpin);
            if(this._restore && this._toMode === "FREESPIN") {
                (<HarlequinBackground>HarlequinGameModuleConfig.background).playBgSpine("bonusGame");
            }
        }
        else {
            HarlequinGameModuleConfig.harlequinSignView.enterMode(this._fromMode, this._toMode);
        }
        super.finish();
    }

    start() {
        HarlequinGameModuleConfig.CURRENT_MODE = this._toMode;

        if(this._restore && (this._toMode === "FREESPIN" || this._toMode === "WILD_RESPIN_FS")) {
            HarlequinGameModuleConfig.harlequinWalkerView.restoreWilds(this._wildMultipliers, 0);
        }

        super.start();
    }

    protected calculateIsTriggeredThisSpin(data:ParsedServerData):boolean {
        if(this._restore && data.mode === "WILD_RESPIN" && data.nextMode === "FREESPIN") {
            return true;
        }
        else {
            return this._fromMode == data.mode && this._toMode == data.nextMode;
        }
    }

    protected onGameDataParsed(data: ParsedServerData): void {
        this._restore = (<any>data).isRestoreState;
        this._freespinTriggeredThisSpin =(<HarlequinParsedGameData> data).freespinTriggeredThisSpin;
        this._wildMultipliers = (<any>data).wildMultipliers || [];
        super.onGameDataParsed(data);
    }

}